import { ServerSideProcessingColumnsInterface } from "../../Type/DataTable";

export const SERVER_DATA = [
    {
    name:"Angelica",
    position:"Chief Executive Officer (CEO)",
    office:"London",
    lastName:"Ramos",
    date:"2009/10/09",
    salary:"$1,200,000"
    },
    {
    name:"Archana",
    position:"Accountant",
    office:"Tokyo",
    lastName:"Desai",
    date:"2008/11/28",
    salary:"$162,700"
    },
    {
    name:"Ashton",
    position:"Junior Technical Author",
    office:"San Francisco",
    lastName:"Cox",
    date:"2009/01/12",
    salary:"$86,000"
    },
    {
    name:"Bradley",
    position:"Software Engineer",
    office:"London",
    lastName:"Greer",
    date:"2012/10/13",
    salary:"$132,000"
    },
    {
    name:"Brenden",
    position:"Software Engineer",
    office:"San Francisco",
    lastName:"Wagner",
    date:"2011/06/07",
    salary:"$206,850"
    },
    {
    name:"Bruno",
    position:"Software Engineer",
    office:"London",
    lastName:"Nash",
    date:"2011/05/03",
    salary:"$163,500"
    },
    {
    name:"Caesar",
    position:"Pre-Sales Support",
    office:"New York",
    lastName:"Vance",
    date:"2011/12/12",
    salary:"$106,450"
    },
    {
    name:"Cara",
    position:"Sales Assistant",
    office:"New York",
    lastName:"Stevens",
    date:"2011/12/06",
    salary:"$145,600"
    },
    {
    name:"Cedric",
    position:"Senior Javascript Developer",
    office:"Edinburgh",
    lastName:"Kelly",
    date:"2012/03/29",
    salary:"$433,060"
    },
    {
    name:"Charde",
    position:"Regional Director",
    office:"San Francisco",
    lastName:"Marshall",
    date:"2008/10/16",
    salary:"$470,600"
    },
    {
    name:"Dai",
    position:"Personnel Lead",
    office:"Edinburgh",
    lastName:"Rios",
    date:"2012/09/26",
    salary:"$217,500"
    },
    {
    name:"Doris",
    position:"Sales Assistant",
    office:"Sidney",
    lastName:"Wilder",
    date:"2010/09/20",
    salary:"$85,600"
    },
    {
    name:"Fiona",
    position:"Chief Executive Officer (CEO)",
    office:"San Francisco",
    lastName:"Green",
    date:"2010/03/11",
    salary:"$850,000"
    },
    {
    name:"Garrett",
    position:"Accountant",
    office:"Tokyo",
    lastName:"Winters",
    date:"2011/07/25",
    salary:"$170,750"
    },
    {
    name:"Gavin",
    position:"Team Leader",
    office:"San Francisco",
    lastName:"Cortez",
    date:"2008/10/26",
    salary:"$235,500"
    },
    {
    name:"Gavin",
    position:"Developer",
    office:"Edinburgh",
    lastName:"Joyce",
    date:"2010/12/22",
    salary:"$92,575"
    },
    {
    name:"Gloria",
    position:"Systems Administrator",
    office:"New York",
    lastName:"Little",
    date:"2009/04/10",
    salary:"$237,500"
    },
    {
    name:"Haley",
    position:"Senior Marketing Designer",
    office:"London",
    lastName:"Kennedy",
    date:"2012/12/18",
    salary:"$313,500"
    },
    {
    name:"Herrod",
    position:"Sales Assistant",
    office:"San Francisco",
    lastName:"Chandler",
    date:"2012/08/06",
    salary:"$137,500"
    },
    {
    name:"Jena",
    position:"Office Manager",
    office:"London",
    lastName:"Gaines",
    date:"2008/12/19",
    salary:"$90,560"
    },
    {
    name:"Gloria",
    position:"Systems Administrator",
    office:"New York",
    lastName:"Little",
    date:"2009/04/10",
    salary:"$237,500"
    },
    {
    name:"Haley",
    position:"Senior Marketing Designer",
    office:"London",
    lastName:"Kennedy",
    date:"2012/12/18",
    salary:"$313,500"
    },
    {
    name:"Hermione",
    position:"Regional Director",
    office:"London",
    lastName:"Butler",
    date:"2011/03/21",
    salary:"$356,250"
    },
    {
    name:"Herrod",
    position:"Sales Assistant",
    office:"San Francisco",
    lastName:"Chandler",
    date:"2012/08/06",
    salary:"$137,500"
    },
   
    {
    name:"Hope",
    position:"Secretary",
    office:"San Francisco",
    lastName:"Fuentes",
    date:"2010/02/12",
    salary:"$109,850"
    },
    {
    name:"Howard",
    position:"Office Manager",
    office:"San Francisco",
    lastName:"Hatfield",
    date:"2008/12/16",
    salary:"$164,500"
    },
    {
    name:"Jackson",
    position:"Director",
    office:"New York",
    lastName:"Bradshaw",
    date:"2008/09/26",
    salary:"$645,750"
    },
    {
    name:"Jena",
    position:"Office Manager",
    office:"London",
    lastName:"Gaines",
    date:"2008/12/19",
    salary:"$90,560"
    },
    {
    name:"Jenette",
    position:"Development Lead",
    office:"New York",
    lastName:"Caldwell",
    date:"2011/09/03",
    salary:"$345,000"
    },
    {
    name:"Jennifer",
    position:"Junior Javascript Developer",
    office:"Edinburgh",
    lastName:"Acosta",
    date:"2013/02/01",
    salary:"$75,650"
    },
    {
    name:"Bruno",
    position:"Software Engineer",
    office:"London",
    lastName:"Nash",
    date:"2011/05/03",
    salary:"$163,500"
    },
    {
    name:"Caesar",
    position:"Pre-Sales Support",
    office:"New York",
    lastName:"Vance",
    date:"2011/12/12",
    salary:"$106,450"
    },
    {
    name:"Cara",
    position:"Sales Assistant",
    office:"New York",
    lastName:"Stevens",
    date:"2011/12/06",
    salary:"$145,600"
    },
    {
    name:"Cedric",
    position:"Senior Javascript Developer",
    office:"Edinburgh",
    lastName:"Kelly",
    date:"2012/03/29",
    salary:"$433,060"
    },
    {
    name:"Charde",
    position:"Regional Director",
    office:"San Francisco",
    lastName:"Marshall",
    date:"2008/10/16",
    salary:"$470,600"
    },
    {
    name:"Archana",
    position:"Accountant",
    office:"Tokyo",
    lastName:"Desai",
    date:"2008/11/28",
    salary:"$162,700"
    },
    {
    name:"Ashton",
    position:"Junior Technical Author",
    office:"San Francisco",
    lastName:"Cox",
    date:"2009/01/12",
    salary:"$86,000"
    },
    {
    name:"Bradley",
    position:"Software Engineer",
    office:"London",
    lastName:"Greer",
    date:"2012/10/13",
    salary:"$132,000"
    },
    {
    name:"Brenden",
    position:"Software Engineer",
    office:"San Francisco",
    lastName:"Wagner",
    date:"2011/06/07",
    salary:"$206,850"
    },
    {
    name:"Bruno",
    position:"Software Engineer",
    office:"London",
    lastName:"Nash",
    date:"2011/05/03",
    salary:"$163,500"
    },
    {
    name:"Herrod",
    position:"Sales Assistant",
    office:"San Francisco",
    lastName:"Chandler",
    date:"2012/08/06",
    salary:"$137,500"
    },
    {
    name:"Jena",
    position:"Office Manager",
    office:"London",
    lastName:"Gaines",
    date:"2008/12/19",
    salary:"$90,560"
    },
    {
    name:"Gloria",
    position:"Systems Administrator",
    office:"New York",
    lastName:"Little",
    date:"2009/04/10",
    salary:"$237,500"
    },
    {
    name:"Haley",
    position:"Senior Marketing Designer",
    office:"London",
    lastName:"Kennedy",
    date:"2012/12/18",
    salary:"$313,500"
    },
    {
    name:"Hermione",
    position:"Regional Director",
    office:"London",
    lastName:"Butler",
    date:"2011/03/21",
    salary:"$356,250"
    },
    {
    name:"Cedric",
    position:"Senior Javascript Developer",
    office:"Edinburgh",
    lastName:"Kelly",
    date:"2012/03/29",
    salary:"$433,060"
    },
    {
    name:"Charde",
    position:"Regional Director",
    office:"San Francisco",
    lastName:"Marshall",
    date:"2008/10/16",
    salary:"$470,600"
    },
    {
    name:"Dai",
    position:"Personnel Lead",
    office:"Edinburgh",
    lastName:"Rios",
    date:"2012/09/26",
    salary:"$217,500"
    },
    {
    name:"Doris",
    position:"Sales Assistant",
    office:"Sidney",
    lastName:"Wilder",
    date:"2010/09/20",
    salary:"$85,600"
    },
    {
    name:"Fiona",
    position:"Chief Executive Officer (CEO)",
    office:"San Francisco",
    lastName:"Green",
    date:"2010/03/11",
    salary:"$850,000"
    },
    {
    name:"Jennifer",
    position:"Junior Javascript Developer",
    office:"Edinburgh",
    lastName:"Acosta",
    date:"2013/02/01",
    salary:"$75,650"
    },
    {
    name:"Bruno",
    position:"Software Engineer",
    office:"London",
    lastName:"Nash",
    date:"2011/05/03",
    salary:"$163,500"
    },
    {
    name:"Caesar",
    position:"Pre-Sales Support",
    office:"New York",
    lastName:"Vance",
    date:"2011/12/12",
    salary:"$106,450"
    },
    {
    name:"Cara",
    position:"Sales Assistant",
    office:"New York",
    lastName:"Stevens",
    date:"2011/12/06",
    salary:"$145,600"
    },
    {
    name:"Cedric",
    position:"Senior Javascript Developer",
    office:"Edinburgh",
    lastName:"Kelly",
    date:"2012/03/29",
    salary:"$433,060"
    },
    {
    name:"Charde",
    position:"Regional Director",
    office:"San Francisco",
    lastName:"6741",
    date:"2008/10/16",
    salary:"$470,600"
    },
    {
    name:"Archana",
    position:"Accountant",
    office:"Tokyo",
    lastName:"Desai",
    date:"2008/11/28",
    salary:"$162,700"
    }
   ]

   export const SERVER_COLUMN = [
    {
      name: "First Name",
      selector: (row: ServerSideProcessingColumnsInterface) => row.name,
      sortable: true,
      center: false,
    },
    {
      name: "Last Name",
      selector: (row: ServerSideProcessingColumnsInterface) => row.lastName,
      sortable: true,
      center: false,
    },
    {
      name: "position",
      selector: (row: ServerSideProcessingColumnsInterface) => row.position,
      sortable: true,
      center: false,
    },
    {
      name: "office",
      selector: (row: ServerSideProcessingColumnsInterface) => row.office,
      sortable: true,
      center: false,
    },
    {
      name: "Start Date",
      selector: (row: ServerSideProcessingColumnsInterface) => row.date,
      sortable: true,
      center: false,
    },
    {
      name: "Salary",
      selector: (row: ServerSideProcessingColumnsInterface) => row.salary,
      sortable: true,
      center: false,
    },
  ];